// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import textColorStyles from '../../../styles/atoms/text-color.module.css'
import {
  IconProps,
  computeStrokeWidth,
  computeSize,
  IconComponentRef,
} from '../helpers'
const IgTextIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'ig-text'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(
          className,
          styles.base,
          color && textColorStyles[color],
        )}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.82991 21.126C1.61234 21.126 1.45441 20.92 1.51191 20.7112L6.32217 3.24141C6.36142 3.09884 6.49163 3 6.64017 3H8.21388C8.36231 3 8.49244 3.0987 8.5318 3.24112L13.3596 20.7109C13.4173 20.9198 13.2594 21.126 13.0417 21.126H11.327C11.1759 21.126 11.0441 21.0238 11.0072 20.8779L10.0597 17.1289C10.0228 16.9831 9.89104 16.8808 9.73992 16.8808H5.12069C4.9695 16.8808 4.83768 16.9832 4.80088 17.1291L3.85558 20.8778C3.81878 21.0237 3.68697 21.126 3.53578 21.126H1.82991ZM7.74741 7.98046C7.66378 7.64958 7.19129 7.64971 7.10784 7.98063L5.59108 13.9955C5.53884 14.2026 5.69626 14.4035 5.91089 14.4035H8.94789C9.1626 14.4035 9.32003 14.2025 9.26766 13.9953L7.74741 7.98046Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.3779 19.8935C20.3745 19.8608 20.3315 19.8501 20.3127 19.8772C20.2415 19.9794 20.1661 20.0803 20.0865 20.1799C19.8072 20.5285 19.4702 20.8148 19.0756 21.0389C18.687 21.263 18.2377 21.375 17.7276 21.375C17.084 21.375 16.5102 21.2007 16.0063 20.8521C15.5023 20.4953 15.1077 20.018 14.8223 19.4205C14.5369 18.8146 14.3943 18.1299 14.3943 17.3664C14.3943 16.6526 14.4914 16.0218 14.6857 15.4741C14.8861 14.918 15.1775 14.4533 15.56 14.0798C15.9486 13.7063 16.4222 13.4241 16.9808 13.2332C17.5394 13.034 18.1769 12.9345 18.8934 12.9345H19.9662C20.1483 12.9345 20.296 12.7875 20.296 12.6063V12.0008C20.296 11.5194 20.2322 11.1044 20.1047 10.7558C19.9772 10.4073 19.7829 10.1375 19.5218 9.94665C19.2668 9.75576 18.945 9.66032 18.5564 9.66032C18.1982 9.66032 17.8885 9.74331 17.6274 9.9093C17.3664 10.0753 17.163 10.2994 17.0172 10.5816C16.9176 10.7746 16.852 10.985 16.8205 11.213C16.7957 11.3925 16.651 11.5401 16.4689 11.5401H14.9426C14.7605 11.5401 14.6115 11.393 14.6249 11.2123C14.6558 10.7966 14.7459 10.3913 14.8952 9.99644C15.0834 9.49848 15.3566 9.05445 15.7149 8.66438C16.0731 8.27431 16.5011 7.96723 16.999 7.74314C17.4969 7.51906 18.0555 7.40701 18.6748 7.40701C19.4156 7.40701 20.0713 7.57715 20.6421 7.91743C21.2189 8.25771 21.6712 8.77227 21.9991 9.46113C22.333 10.1417 22.5 10.9965 22.5 12.0257V20.7979C22.5 20.9791 22.3524 21.126 22.1703 21.126H20.8651C20.7215 21.126 20.5934 21.0337 20.5576 20.8952C20.4849 20.6138 20.425 20.2799 20.3779 19.8935ZM20.296 17.2648C20.296 17.3036 20.2892 17.3422 20.275 17.3783C20.2346 17.4806 20.1869 17.5845 20.132 17.69C19.9377 18.0552 19.6706 18.3664 19.3306 18.6237C18.9966 18.8727 18.605 18.9972 18.1557 18.9972C17.8217 18.9972 17.5364 18.9142 17.2996 18.7482C17.0688 18.5822 16.8928 18.354 16.7713 18.0635C16.6499 17.7647 16.5892 17.4369 16.5892 17.08C16.5892 16.7232 16.6408 16.4036 16.744 16.1214C16.8472 15.8393 17.0021 15.5986 17.2085 15.3994C17.4149 15.2002 17.673 15.0508 17.9826 14.9512C18.2923 14.8433 18.6505 14.7894 19.0573 14.7894H19.9662C20.1483 14.7894 20.296 14.9363 20.296 15.1175V17.2648Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
IgTextIcon.displayName = 'IgTextIcon'
export { IgTextIcon }
